import { render, staticRenderFns } from "./MediaGallery.vue?vue&type=template&id=4e9e07fc"
import script from "./MediaGallery.vue?vue&type=script&lang=ts"
export * from "./MediaGallery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports